import serviceHome from "../../services/home";
import * as constant from "./constant";

export function setLoading(payload) {
  return { type: constant.LOADING, payload: payload };
}

export function setMicOpen(payload) {
  return { type: constant.MIC_OPEN, payload: payload };
}

export function setHistoryChat(payload) {
  return { type: constant.HISTORY_CHAT, payload: payload };
}

export function historyChat(pageNumber = "") {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceHome.historyChat(pageNumber);
      dispatch(setHistoryChat(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}
